import {round} from '@ivosabev/helpers/round';

export function calcSavings(numberOfDeliveries: number, numberOfVehicles: number) {
  const daysPerMonth = 25;
  const hoursPerDay = 8;
  const fuelPrice = 3.95; // $
  const milesPerMonth = 2500; // miles
  const driverHourRate = 18; // $
  const officeHourRate = 20; // $
  const fuelConsumption = 30; // MPG

  const A = 10;
  const B = 0.1;
  const C = 0.5;
  const e = 2.718281828459045;
  const logisticsGrowthIndex = C / (1 + A * Math.pow(e, -1 * B * numberOfVehicles));
  const savingsCoefficient =
    ((18 - (numberOfDeliveries / daysPerMonth / (hoursPerDay * numberOfVehicles)) * 1.99) / 100) * (1 - logisticsGrowthIndex);

  const savings = {
    driverHourRate,
    driverHoursSavedFromCommunicaion: round(0.85 * savingsCoefficient * numberOfVehicles * daysPerMonth * hoursPerDay, 0),
    driverHoursSavedFromRouting: round(savingsCoefficient * numberOfVehicles * daysPerMonth * hoursPerDay, 0),
    fuelConsumption,
    fuelPrice,
    milesPerMonth,
    milesSavedFromRouting: round(savingsCoefficient * milesPerMonth * numberOfVehicles, 0),
    monthlyCO2Savings: round((milesPerMonth / fuelConsumption) * savingsCoefficient * 20 * numberOfVehicles, 0),
    monthlyDriverSavings: round(numberOfVehicles * driverHourRate * 1.85 * savingsCoefficient * daysPerMonth * hoursPerDay, 0),
    monthlyFuelSavings: round(((savingsCoefficient * numberOfVehicles * milesPerMonth) / fuelConsumption) * fuelPrice, 0),
    monthlyGallonsSavings: round((milesPerMonth / fuelConsumption) * savingsCoefficient * numberOfVehicles, 0),
    monthlyOfficeSavings: round((1 + numberOfVehicles / 30) * 0.6 * savingsCoefficient * daysPerMonth * hoursPerDay * officeHourRate, 0),
    officeHourRate,
    officeHoursSavedFromCommunication: round((1 + numberOfVehicles / 30) * 0.1 * savingsCoefficient * daysPerMonth * hoursPerDay, 0),
    officeHoursSavedFromNotifications: round((1 + numberOfVehicles / 30) * 0.2 * savingsCoefficient * daysPerMonth * hoursPerDay, 0),
    officeHoursSavedFromRouting: round((1 + numberOfVehicles / 30) * 0.3 * savingsCoefficient * daysPerMonth * hoursPerDay, 0),
  };

  const monthlySavings = round(savings.monthlyDriverSavings + savings.monthlyFuelSavings + savings.monthlyOfficeSavings, 0);

  // console.log('savingCoefficient', savingsCoefficient);
  // console.log('augmentFunction', augmentFunction);
  // console.log('monthlySaving', monthlySavings);
  // console.log({...savings, monthlySavings});

  return {...savings, monthlySavings};
}
